const skbv = {
  fontFamilyPrimary: 'aktiv-grotesk, sans-serif',
  fontFamilySecondary: 'united-sans, sans-serif',
  fontsizeH1Mobile: '28px',
  fontsizeH1Desktop: '40px',
  fontColorPrimary: '#1b5f4b',
  fontWeightBold: 500,
  textDecorationLinkHover: 'underline',
  white: '#ffffff',
  black: '#1d1d1b',
  primary: '#1b5f4b',
  linkColorPrimaryHover: '#1b5f4b',
  secondary: '#faf9f8',
  lightGrey: '#faf9f8',
  progressBar: '#1b5f4b',
  hoverPrimary: '#438d6d',
  dark: '#438d6d',
  grey: '#888888',
  darkGrey: '#4f504a',
  red: '#e30613',
  link: '#1b5f4b',
  discount: '#a5423f',
  input: '#1d1d1d',
  tableHeader: '#ebebdb',
  hover: '#c1dfd4',
  spinner: '#1b5f4b',
  headingTransform: 'uppercase',
  inspirationText: '#1b5f4b',
};

const nordrum = {
  fontFamilyPrimary: 'poppins, sans-serif',
  fontFamilySecondary: 'poppins, sans-serif',
  fontsizeH1Mobile: '1.875rem',
  fontsizeH1Desktop: '1.875rem',
  fontColorPrimary: '#000000',
  fontWeightBold: 600,
  textDecorationLinkHover: 'none',
  white: '#ffffff',
  black: '#1d1d1b',
  primary: '#65b32e',
  linkColorPrimaryHover: '#466d46',
  secondary: '#f1f1f2',
  lightGrey: '#f2f3ec',
  progressBar: '#2e2e2e',
  hoverPrimary: '#1e1e1e',
  dark: '#466d46',
  grey: '#888888',
  darkGrey: '#616161',
  red: '#e30613',
  link: '#65b32e',
  discount: '#a70000',
  input: '#111111',
  tableHeader: '#d8d4c4',
  hover: '#d8d4c4',
  spinner: '#65b32e',
  headingTransform: 'unset',
  inspirationText: '#324c31',
};

export const getTheme = (channelId) => {
  switch (channelId) {
    case '1':
    case '2':
      return skbv;
    case '7':
    case '8':
      return nordrum;
    default:
      return skbv;
  }
};
